// extracted by mini-css-extract-plugin
export default {"custom-cascader":"index_custom-cascader__EqEUo"};